// 会员管理路由
export default {
    path: 'Members',
    component: () => import('@/components/RouterView'),
    redirect: 'noRedirect',
    meta: {title: '会员管理'},
    children: [
        //列表
        {
            path: 'list',
            component: () => import('@/views/Members/list/index'),
            meta: { title: '会员管理列表'},
			props: true
        },
		//订单列表
		{
		    path: 'order/list',
		    component: () => import('@/views/Members/order/list'),
		    meta: { title: '订单列表'},
			props: true
		},
		{
			path: 'order/details/:id',
			component: () => import('@/views/Members/order/details'),
			meta: { title: '订单详情' },
			props: true
		}
    ]
};
